export const userConstants = {
  LOAD: 'profile/LOAD',
  LOAD_SUCCESS: 'profile/LOAD_SUCCESS',
  LOAD_FAIL: 'profile/LOAD_FAIL',
  FLUSH: 'profile/FLUSH',
  PROFILE: 'profile/PROFILE',
};
